import React, { useState } from 'react';
import api from '../services/api';
import { Link } from 'react-router-dom';
import '../styles/auth.css';

const ForgotPassword = () => {
  const [identifier, setIdentifier] = useState('');
  const [message, setMessage] = useState('');

  const handleForgotPassword = async () => {
    try {
      const response = await api.post('/auth/forgot-password', { identifier });
      setMessage(response.data.message || 'E-mail de recuperação enviado com sucesso.');
    } catch (error) {
      setMessage(error.response?.data?.error || 'Erro ao enviar e-mail de recuperação.');
    }
  };

  const handleInputChange = (e) => {
    let value = e.target.value;

    // Remove non-numeric characters to check if it's potentially a CPF
    const numbersOnly = value.replace(/\D/g, '');

    // Check if the user is typing only numbers (potential CPF)
    // If there are letters or @, treat as email and don't mask
    const isEmail = /[a-zA-Z@]/.test(value);

    if (!isEmail && numbersOnly.length > 0) {
      // Apply CPF mask: 000.000.000-00
      value = numbersOnly;
      if (value.length > 3) value = value.slice(0, 3) + '.' + value.slice(3);
      if (value.length > 7) value = value.slice(0, 7) + '.' + value.slice(7);
      if (value.length > 11) value = value.slice(0, 11) + '-' + value.slice(11);
      if (value.length > 14) value = value.slice(0, 14); // Limit to 14 chars
    }

    setIdentifier(value);
  };

  return (
    <div className="auth-container">
      <div className="auth-form">
        <h2>Recuperar Senha</h2>
        <div className="form-group">
          <input
            type="text"
            placeholder="Digite seu e-mail ou CPF"
            value={identifier}
            onChange={handleInputChange}
          />
        </div>
        <button onClick={handleForgotPassword}>
          Enviar e-mail de recuperação
        </button>
        <div className="login-link">
          <Link to="/login">Voltar para o login</Link>
        </div>
        {message && <p className="auth-message" style={{ color: message.includes('sucesso') ? 'green' : 'red' }}>{message}</p>}
      </div>
    </div>
  );
};

export default ForgotPassword;
